import React from 'react';
import AskUsContainer from "../askus/AskUsContainer";
import FooterContainer from "../footer/FooterContainer";
import TestimonialsContainer from "../testimonials/TestimonialsContainer";
import MainSectionContainer from "../section/MainSectionContainer";

const CompanyPage  = ({onOrder, webFormRef}) => {
    return (
        <React.Fragment>
            <MainSectionContainer onOrder={onOrder}/>
            <TestimonialsContainer/>
            <AskUsContainer webFormRef={webFormRef}/>
            <FooterContainer/>
        </React.Fragment>
    );
};

export default CompanyPage;


// WEBPACK FOOTER //
// ./src/components/company/view/CompanyPage.jsx